module.exports = __webpack_public_path__ + "static/media/microscope.a00c490f.svg";